import React from 'react';

/**
 * Faixa fixa identificando o ambiente.
 *
 * Existe para uma coisa so: impedir que alguem confunda esta aba com a staging
 * ou com a producao. Os tres tem a mesma interface, e sem marca visivel a
 * unica pista e a URL — que ninguem olha depois do primeiro minuto.
 *
 * Lida de VITE_ENV_BADGE em build time. Vazia (o caso de staging e producao),
 * o componente nao renderiza nada e nao ocupa espaco.
 */
const EnvironmentBadge: React.FC = () => {
  const label = (import.meta.env.VITE_ENV_BADGE ?? '').trim();

  if (!label) return null;

  return (
    <div
      role="status"
      aria-label={`Ambiente: ${label}`}
      className="fixed bottom-0 inset-x-0 z-[60] pointer-events-none select-none"
    >
      <div className="flex justify-center">
        <span className="mb-0 rounded-t-md bg-amber-500/90 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-amber-950 shadow-lg">
          {label}
        </span>
      </div>
    </div>
  );
};

export default EnvironmentBadge;
